import React from "react";
import "./Footer.scss";

export const Footer: React.FC = () => {
  return (
    <div className="app-footer">
      <div className="container">
        <div className="footer-title">
          <h1> <strong> Let's break language barriers.<br />Together.</strong></h1>
          </div>
        <div className="b-link">
          <a href="https://sites.google.com/view/superprivategallery/home/privacy-policy">Privacy Policy</a>
        </div>
        <div className="b-link">
          <a href="https://sites.google.com/view/superprivategallery/home/terms-of-service">Terms of Service</a>
        </div>
        <div className="t-copyright">© 2022 SuperTools All Rights Reserved.</div>
      </div>
    </div>
  );
};
